import { Loader2 } from 'lucide-react'
import { Navigate } from 'react-router'
import { useGetUserSession } from '@/shared/hooks/api/auth'

type ArtemEarthOnlyRouteProps = {
  children: React.ReactNode
}

export function ArtemEarthOnlyRoute({ children }: ArtemEarthOnlyRouteProps) {
  const { data: session, isFetched } = useGetUserSession()

  if (!isFetched) {
    return (
      <div className='flex min-h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin text-muted-foreground' />
      </div>
    )
  }

  if (!session?.isArtemAdmin) {
    return <Navigate to='/product-catalog' replace />
  }

  return <>{children}</>
}
